<!--
 * @Author: Merlin
 * @Date: 2023-12-01 15:44:20
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-18 14:30:38
 * @Description: 
-->

<template>
    <div class="smoke-wrap">
        <canvas class="canvas"
            ref="oCanvas"
            width="500"
            height="450"
        ></canvas>
    </div>
</template>

<script setup>
const oCanvas = ref(null);

// ↓ 气泡类
class Ball {
    iBeginAt = 0; // 动画开始时间
    fWholeLife = 0.5; // 气泡存活时间 
    constructor(oConfig){
        this.iSizeFrom = oConfig.iSizeFrom;
        this.iSize = oConfig.iSize; // size to
        this.left = oConfig.left;
        this.top = oConfig.top;
        this.sideL = oConfig.sideL;
        this.propsType = oConfig.propsType;
        this.iBeginAt = Date.now() + oConfig.iDelay * 1000;
    }
    getStatus(){
        const iPastSec = (Date.now() - this.iBeginAt) / 1000;
        if (iPastSec < 0) return 0; // 未开始
        if (iPastSec > this.fWholeLife) return null; // 已结束
        let fRate = Math.min(1, iPastSec / this.fWholeLife);
        const {iSizeFrom, iSize} = this;
        const iSizeNow = iSizeFrom + (iSize - iSizeFrom) * fRate;
        const oStatus = {
            iSize: iSizeNow,
            top: this.top * fRate,
            left: this.left * fRate,
            sideL: this.sideL,
            fRate,
        };
        return oStatus;
    }
}

function runner(config){
    let {ctx, arr, width, height} = config;
    draw();
    function draw() {
        ctx.clearRect(0, 0, width, height);
        // const t01 = Date.now();
        arr = arr.filter(oThisBall => {
            const oStatus = oThisBall.getStatus();
            if (oStatus === null) return false;
            if (oStatus === 0) return true;
            const {propsType, iSize, left, top, fRate,} = oStatus;
            ctx.beginPath();
            let iSetLeft = 20 * (oThisBall.sideL ? -1 : 1);
            if (propsType == 's1'){
                iSetLeft *= 3.6;
            }
            ctx.lineTo(
                width * 0.5 + left + iSetLeft,
                height * 0.5 + top,
            );
            const fAlpha = Math.min(0.9, 1 - fRate);
            ctx.strokeStyle = `rgba(255, 255, 255, ${fAlpha})`;
            ctx.lineWidth = iSize;
            ctx.stroke();
            return true;
        });
        // console.log("循环耗时：", Date.now() - t01); // 耗时≈ 1ms 可忽略 
        // console.log("arr.length", arr.length);
        if (arr.length){
            requestAnimationFrame(draw);
        }
    }
}

function init(){
    if (!oCanvas.value) return;
    // console.log("oCanvas.value\n", oCanvas.value);
    const t01 = Date.now();
    var arr = getBigArr();
    // console.log('生成气泡耗时：', Date.now() - t01); // ≈ 2ms 
    const {width, height} = oCanvas.value;
    const ctx = oCanvas.value.getContext("2d");
    if (ctx) ctx.lineCap = 'round'; // 恒定值，无变化
    setTimeout(() => {
        runner({
            ctx, arr, width, height,
        });
    });
}

onMounted(()=>{
    init();
});


function getBigArr(){
    var arr1 = getBubbleList01().map(cur=>{
        cur.iSizeFrom = 55;
        return new Ball(cur);
    });
    var arr2 = getBubbleList01().map(cur=>{
        cur.sideL = true;
        cur.iSizeFrom = 55;
        return new Ball(cur);
    });
    var arr3 = getBubbleList02().map(cur=>{
        cur.iSizeFrom = 10;
        return new Ball(cur);
    });
    var arr4 = getBubbleList02().map(cur=>{
        cur.sideL = true;
        cur.iSizeFrom = 10;
        return new Ball(cur);
    });
    const oResult = [
        ...arr1, ...arr2, ...arr3, ...arr4,
    ];
    // console.log("oResult", deepCopy(oResult));
    return oResult;
}

function getBubbleList01(){
    let arr = [
        ...createBubbles(6, 0.0, 's1'),
        ...createBubbles(6, 0.1, 's1'),
        ...createBubbles(6, 0.2, 's1'),
        ...createBubbles(8, 0.3, 's1'),
        ...createBubbles(8, 0.4, 's1'),
        ...createBubbles(14, 0.9, 's1'),
        ...createBubbles(10, 1.2, 's1'),
    ];
    return arr;
}

function getBubbleList02(){
    const fDelaySec = 1.2;
    let arr = [
        ...createBubbles(8, fDelaySec + 1.0, 's2'),
        ...createBubbles(14, fDelaySec + 1.3, 's2'),
        ...createBubbles(18, fDelaySec + 1.6, 's2'),
        ...createBubbles(16, fDelaySec + 1.9, 's2'),
        ...createBubbles(8, fDelaySec + 2.1, 's2'),
    ];
    return arr;
}

// ▼生成多个气泡
function createBubbles(iLen, iDelay, propsType){
    const aResult = Array(iLen).fill(0).map(cur => {
        const oThis = createOneBubble(iDelay, propsType);
        return oThis;
    });
    return aResult;
}

// ▼生成1个气泡
function createOneBubble(iDelay, propsType){
    let aMoveHorizontal  = [];
    let aMoveVertical  = [];
    let aSize = [120, 160];
    let iMoveLong = 75;
    if (propsType == 's1'){
        aMoveHorizontal  = [iMoveLong * -1, iMoveLong];
        aMoveVertical  = aMoveHorizontal;
    }else{
        iMoveLong = 15;
        aSize = [20, 50];
        aMoveHorizontal  = [iMoveLong * -1, iMoveLong];
        aMoveVertical  = [110, 170];
    }
    const oBubble = {
        iDelay: getRandomInt(iDelay, iDelay + 0.5),
        iSize: ~~getRandomInt(...aSize),
        left: ~~getRandomInt(...aMoveHorizontal),
        top: ~~getRandomInt(...aMoveVertical),
        propsType,
    };
    return oBubble;
}

// ▼取得一个随机数
function getRandomInt(min, max) {
    const step1 = (Math.random() * (max - min + 1));
    return (step1 + min).toFixed(1) * 1;
}

defineExpose({
    init, // 好像没用到
});

</script>

<style lang="scss" scoped>
.smoke-wrap{
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    color: white;
    display: flex;
    justify-content: center;
    flex-direction: row;
    pointer-events: none !important;
}

</style>

